
import { defineComponent, reactive, ref, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  setup() {
    const router = useRouter()
    const internalInstance = getCurrentInstance()
    const refFrmReset: any = ref(null)
    const message = reactive({
      msg: '',
      err: false
    })
    const frmReset = reactive({
      user_id: ''
    })
    const rules = {
      user_id: [
        { required: true, message: 'ユーザIDを入力してください。', trigger: 'blur' },
      ],
    }
    const back = () => {
      router.back()
    }
    const onSubmit = () => {
      const api_path = internalInstance?.appContext.config.globalProperties.api_path
      refFrmReset.value.validate((valid: boolean) => {
        if(valid) {
          fetch(api_path + 'ajax/pwresetreq.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(frmReset)
          })
          .then(response => response.json())
          .then(json => {
            //console.log(json);
            if(json['result'] == 'failure') {
              message.msg = json['error'];
              message.err = true;
            }else {
              message.msg = "パスワードリセット用のリンクを送信しました。";
              message.err = false;
            }
          })
          .catch(error => console.error(error))
        }else {
          console.log('invalid')
        }
      })
    }

    return {
      refFrmReset,
      frmReset,
      message,
      rules,
      back,
      onSubmit
    }
  }
})
